export const SMALL_SIZE = 'small';
export const LARGE_SIZE = 'large';
export const FIELD_NUMBER_SKELETON = [
    {
        type: 'group',
        items: [
            {
                type: 'rect', width: '120px', height: '56px', className: 'mr-2.5'
            }
        ]
    }
];
